import { DBCheckbox } from "@db-ux/react-core-components";
import React from "react";
import type { ComponentProps } from "react";
import "./REDCheckbox.css";

type REDCheckboxProps = ComponentProps<typeof DBCheckbox> & {
    /**
     * Keep error text in small size.
     * Default: false (error text will be displayed in normal/larger size)
     */
    keepSmallErrorText?: boolean;
};

const REDCheckbox: React.FC<REDCheckboxProps> = (props) => {
    const { keepSmallErrorText, ...dbCheckboxProps } = props;

    // Check if we should hide the invalid message icon
    const shouldHideInvalidIcon = dbCheckboxProps.validation === "invalid" && !dbCheckboxProps.invalidMessage;

    // Build wrapper class names
    const wrapperClasses = [
        shouldHideInvalidIcon ? "hideInvalidIcon" : "",
        keepSmallErrorText !== true ? "normalErrorText" : ""
    ].filter(Boolean).join(" ");

    return (
        <div className={wrapperClasses}>
            <DBCheckbox
                {...dbCheckboxProps}
                invalidMessage={shouldHideInvalidIcon ? " " : dbCheckboxProps.invalidMessage}
            >
                {props.children}
            </DBCheckbox>
        </div>
    );
};

export default REDCheckbox;